export const priceTagConstants = {
  GET_PRICE_TAGS: "GET_PRICE_TAGS",
  SET_PRICE_TAGS: "SET_PRICE_TAGS",
};
